"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var button_component_1 = __importDefault(require("../inputs/button.component"));
var date_range_picker_styles_1 = require("./date-range-picker.styles");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var FooterContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  grid-column-start: 1;\n  grid-column-end: 3;\n  grid-row: 2;\n  padding: 12px 28px;\n  border-top: 1px solid\n    ", ";\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  grid-column-start: 1;\n  grid-column-end: 3;\n  grid-row: 2;\n  padding: 12px 28px;\n  border-top: 1px solid\n    ",
    ";\n  display: flex;\n  justify-content: flex-end;\n"])), function (_a) {
    var dateRangePicker = _a.theme.colours.dateRangePicker;
    return dateRangePicker.color;
});
FooterContainer.displayName = 'FooterContainer';
var FooterPickerLink = styled_components_1.default(date_range_picker_styles_1.PickerLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 96px;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  cursor: ", ";\n"], ["\n  width: 96px;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  cursor: ", ";\n"])), function (_a) {
    var isEnabled = _a.isEnabled;
    return (isEnabled ? 'pointer' : 'default');
});
FooterPickerLink.displayName = 'FooterPickerLink';
var FooterButton = styled_components_1.default(button_component_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 96px;\n  min-width: unset;\n"], ["\n  width: 96px;\n  min-width: unset;\n"])));
FooterButton.displayName = 'FooterButton';
var DateRangePickerFooter = function (_a) {
    var apply = _a.apply, cancel = _a.cancel, isEnabled = _a.isEnabled;
    var getTranslation = use_translations_hook_1.default().getTranslation;
    return (react_1.default.createElement(FooterContainer, null,
        react_1.default.createElement(FooterPickerLink, { isEnabled: isEnabled, onClick: cancel }, getTranslation('DATE_RANGE_PICKER:CANCEL')),
        react_1.default.createElement(FooterButton, { testID: "date-picker-apply", onClick: apply }, getTranslation('DATE_RANGE_PICKER:APPLY'))));
};
DateRangePickerFooter.displayName = 'DateRangePickerFooter';
exports.default = DateRangePickerFooter;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=date-range-picker-footer.component.js.map